import { render } from "./selectPAge.vue?vue&type=template&id=8275bf54"
import script from "./selectPAge.vue?vue&type=script&lang=js"
export * from "./selectPAge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__